/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

function BreadCrumbs(props) {
    const { items } = props;
    if (!items || !items.length) {
        return "";
    }

    const length = items.length;
    return (
        <div className="kt-subheader__breadcrumbs">
            {items.map((item, index) => (
                <React.Fragment key={`bc${index}`}>
                    {(items.length === 1) ? (
                        <Link className="kt-subheader__breadcrumbs-link" to={`/`}>
                            Home
                        </Link>
                    ) : (
                    // <Link className="kt-subheader__breadcrumbs-link" to={`/${item.page}`}>
                    //     {item.title}
                    // </Link>
                    //    
                    '' )
                    }
                    {length !== index && (
                        <span className="fa fa-ellipsis-v kt-subheader__breadcrumbs-separator" />
                    )}
                    <Link className="kt-subheader__breadcrumbs-link" to={`/${item.page}`}>
                        {item.title}
                    </Link>
                </React.Fragment>
            ))}
        </div>
    );
}

export default BreadCrumbs;
